import { render } from "./AppLayoutLogin.vue?vue&type=template&id=06857d5e&scoped=true"
import script from "./AppLayoutLogin.vue?vue&type=script&lang=js"
export * from "./AppLayoutLogin.vue?vue&type=script&lang=js"

import "./AppLayoutLogin.vue?vue&type=style&index=0&id=06857d5e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06857d5e"]])

export default __exports__